import * as React from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";

import SEO from "../components/SEO/Seo";
import BannerCarousel from "../components/BannerCarousel/BannerCarousel";
import Layout from "../Layouts/MasterLayout/MasterLayout";

import SeletorModalidade from "../components/Ingresso/SeletorModalidade";
import OpcoesIngresso from "../components/Ingresso/OpcoesIngresso";

import "../components/Ingresso/Ingresso.css";

export default function InscrevasePage() {
	const [modalidade, setModalidade] = React.useState(null);

	return (
		<Layout color="#ffffff">
			<SEO
				title="Ingresse na Universidade Feevale"
				description="Escolha sua modalidade e confira as formas de ingresso disponíveis."
			/>

			<MDBContainer className="ingressoBanner py-4">
				<MDBRow style={{ margin: 0 }}>
					<MDBCol className="my-2 px-0">
						<BannerCarousel bannerKey="00ADA1E5-9470-4B21-80F8-2F8D76761D1F" />
					</MDBCol>
				</MDBRow>
			</MDBContainer>

			<main className="ingressoPage">
				<SeletorModalidade
					modalidade={modalidade}
					onSelect={setModalidade}
				/>

				<OpcoesIngresso modalidade={modalidade} />
			</main>
		</Layout>
	);
}
